import { createBrowserRouter } from 'react-router-dom'
import RootLayout from '@/layouts/root-layout'

// 页面组件懒加载
import { lazy } from 'react'

const HomePage = lazy(() => import('@/pages/home'))
const LevelPage = lazy(() => import('@/pages/level'))
const LuckyGiftsPage = lazy(() => import('@/pages/lucky-gifts'))
const LuckyGiftsRecordPage = lazy(() => import('@/pages/lucky-gifts/record'))
const LuckyGiftsRulePage = lazy(() => import('@/pages/lucky-gifts/rule'))
const RankRulePage = lazy(() => import('@/pages/rank-rule'))
const RechargePage = lazy(() => import('@/pages/recharge'))
const RechargeFAQPage = lazy(() => import('@/pages/recharge/faq'))
const RechargeResultPage = lazy(() => import('@/pages/recharge/result'))
const RoomHourRulePage = lazy(() => import('@/pages/room-hour-rule'))
const TreasureChestPage = lazy(() => import('@/pages/treasure-chest'))
const UploadMP3Page = lazy(() => import('@/pages/upload-mp3'))
const MaintenancePage = lazy(() => import('@/pages/maintenance'))
const InvitationPage = lazy(() => import('@/pages/invitation'))
const InvitationRecordPage = lazy(() => import('@/pages/invitation/invitation-record'))
const InvitationDownloadPage = lazy(() => import('@/pages/invitation/invitation-download'))
const CoinTransferPage = lazy(() => import('@/pages/coin-transfer'))
const FAQPage = lazy(() => import('@/pages/faq'))
const FeedbackPage = lazy(() => import('@/pages/feedback'))
const DragonPage = lazy(() => import('@/pages/dragon'))
const DragonRulePage = lazy(() => import('@/pages/dragon/rule'))
const DragonRedeemPage = lazy(() => import('@/pages/dragon/redeem'))
const ImgViewPage = lazy(() => import('@/pages/img-view'))

// 创建路由配置
export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <HomePage />,
      },
      {
        path: 'level',
        element: <LevelPage />,
      },
      {
        path: 'lucky-gifts',
        element: <LuckyGiftsPage />,
      },
      {
        path: 'lucky-gifts/record',
        element: <LuckyGiftsRecordPage />,
      },
      {
        path: 'lucky-gifts/rule',
        element: <LuckyGiftsRulePage />,
      },
      {
        path: 'rank-rule',
        element: <RankRulePage />,
      },
      {
        path: 'recharge',
        element: <RechargePage />,
      },
      {
        path: 'recharge/faq',
        element: <RechargeFAQPage />,
      },
      {
        path: 'recharge/result',
        element: <RechargeResultPage />,
      },
      {
        path: 'room-hour-rule',
        element: <RoomHourRulePage />,
      },
      {
        path: 'treasure-chest',
        element: <TreasureChestPage />,
      },
      {
        path: 'upload-mp3',
        element: <UploadMP3Page />,
      },
      {
        path: 'maintenance',
        element: <MaintenancePage />,
      },
      {
        path: 'invitation',
        element: <InvitationPage />,
      },
      {
        path: 'invitation/record',
        element: <InvitationRecordPage />,
      },
      {
        path: 'dl',
        element: <InvitationDownloadPage />,
      },
      {
        path: 'coin-transfer',
        element: <CoinTransferPage />,
      },
      {
        path: 'faq',
        element: <FAQPage />,
      },
      {
        path: 'feedback',
        element: <FeedbackPage />,
      },
      {
        path: 'dragon',
        element: <DragonPage />,
      },
      {
        path: 'dragon/rule',
        element: <DragonRulePage />,
      },
      {
        path: 'dragon/redeem',
        element: <DragonRedeemPage />,
      },
      {
        path: 'view',
        element: <ImgViewPage />,
      },
    ],
  },
])
